export class BreadcrumbRouteElement {
  type: 'string' | 'param' | 'queryParam';
  value: string;

  constructor(
    type: 'string' | 'param' | 'queryParam',
    value: string
  ) {
    this.type = type;
    this.value = value;
  }
}
